import { useMutation } from '@tanstack/react-query';

export default function usePostOrganizationStaffInvite() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: { name: string; email: string; is_admin: boolean }) => {
      const response = await fetch('/agent/api/organization/invite', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        throw new Error('Failed to invite staff');
      }

      return await response.json();
    },
  });
}
